<template>
    <div class="ipl-vip-layout-background" :class="$vuetify.breakpoint.mdAndUp ? 'px-12' : 'px-2'">
    <router-view></router-view>
  </div>
</template>
<script>
import { locale, uiHelper } from "@/util";

export default {
  name: 'iplVipLayout',
  metaInfo: {
    title: `${locale.getMessage('meta.default_title')}`,
    titleTemplate: `%s | ${uiHelper.getHost()}`,
    meta: [{ charset: 'utf-8' }, { name: 'description', content: `${locale.getMessage('meta.default_description')}` }, { name: 'keyword', content: `${locale.getMessage('meta.default_keyword')}` }]
  },
  data: () => ({}),
  methods: {
    openLoginDialog() {
      this.$parent.openLoginDialog()
    },
    openRegisterDialog() {
      this.$parent.openRegisterDialog()
    }
  }
}

</script>


<style lang="scss">
.ipl-vip-layout-background {
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
  position: relative;
  margin: 0 auto;
  background-size: 100%;
  background: url('/static/image/background/bb88_ipl_bpass_bg-min.jpg');
}
</style>
